/*
Objects with the `drop-target` directive will respond to dragged objects (via the <drag-anchor> directive) in various ways:
- The `drop-target` class will be set whenever an object is being dragged.
- The `drag-over' class will be set if an object is dragged over this target.
- The `drag-hover` class will be set whenever the mouse hovers over this target.
Use as an alternative to `:hover`, which has quirky behavior in some browsers with dragged objects.
- The `on-drop` callback will give the scopes of both the drag subject and the target (`dragScope`, `dropScope`).

@example

  <drag-anchor/>

  <drag-target on-drop='doSomething(dragScope, dropScope)'>

*/
import {v4 as createUuid} from 'uuid';

export default __filename;
angular.module(__filename, []).directive(
  'dropTarget',
  ngInject(($rootScope) => ({
    restrict: 'AE',

    scope: {onDrop: '&'},

    link(scope, el) {
      let id = angular.element(el).attr('id');
      if (!id) {
        id = createUuid();
        angular.element(el).attr('id', id);
      }
      el.bind('mouseover', (e) => angular.element(e.currentTarget).addClass('drag-hover'));
      el.bind('mouseout', (e) => angular.element(e.currentTarget).removeClass('drag-hover'));
      el.bind('dragover', function(e) {
        e.dataTransfer.dropEffect = 'move';
        return e.preventDefault();
      });
      let dragCounter = 0;

      el.bind('dragenter', function(e) {
        e.preventDefault();
        dragCounter += 1;
        e.dataTransfer.dropEffect = 'move';
        return angular.element(e.currentTarget).addClass('drag-over');
      });

      el.bind('dragleave', function(e) {
        dragCounter -= 1;
        if (dragCounter === 0) {
          return angular.element(e.currentTarget).removeClass('drag-over');
        }
      });

      el.bind('drop', function(e) {
        e.preventDefault();
        dragCounter = 0;
        const data = e.dataTransfer.getData('text');
        const dest = angular.element(document.getElementById(id)).scope();
        const src = angular.element(document.getElementById(data)).scope();
        if (src != null && dest != null) {
          return scope.onDrop({
            dragScope: src,
            dropScope: dest,
          });
        }
      });

      $rootScope.$on('DRAG-START', function() {
        el = document.getElementById(id);
        return angular.element(el).addClass('drop-target');
      });

      return $rootScope.$on('DRAG-END', function() {
        el = document.getElementById(id);
        angular.element(el).removeClass('drop-target');
        return angular.element(el).removeClass('drag-over');
      });
    },
  })),
);
